module.exports = __webpack_public_path__ + "static/media/oberflex-chenenaturel-2560x1440.27ce5e2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-chenenaturel-2560x1440.jpg
// module id = 989
// module chunks = 37